<script>
import footNav from "./stepsFooter.vue";
import headerNav from "./stepsHeader.vue";
import DrawerAside from "./stepsHeaderDrawerAside.vue";


export default {
  name: "uConnectSubscriptionStepsLayout",
  inject: ["reload"],
  data() {
    return {
      unfold: false,
      showFootTxt: true,
      gray: false,
      activeStep: 2,
      userEmail: "",
      form: {
        email: "",
        password: ""
      },
      rules: {
        email: [
          {required: true, message: "Please input your email", trigger: "blur"},
          {type: "email", message: "Please input a valid email", trigger: "blur"}
        ],
      }
    }
  },
  components: {DrawerAside, headerNav,  footNav},
  mounted() {

      this.userEmail = this.$store.state.uConnect.email;

  },
  methods: {
    stepChanged(step) {
      this.activeStep = step;
    },
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    },
  }
}
</script>

<template>
  <el-container :lg="3" :md="4" :sm="6" :xl="1" :xs="8" class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-nav @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <el-steps :active="activeStep-1" align-center finish-status="success">
          <el-step title="Step 1" description="Plan"></el-step>
          <el-step title="Step 2" description="User Details"></el-step>
          <el-step title="Step 3" description="payment"></el-step>
        </el-steps>
        <router-view @stepChanged="stepChanged"></router-view>
      </el-main>
      <el-footer style="padding: 0">
        <foot-nav :showQus="showFootTxt"></foot-nav>
      </el-footer>

      </el-container>
  </el-container>
</template>

<style scoped lang="css">
.mainWrapper {
  background-color: #ffffff;
  max-width: 1920px;
  margin: auto;
  min-height: 89.5vh;
}

</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/uConnectSubscriptionStepsLayout.vue